import React from 'react';
import type { LscArchiveItem } from '../types';

/**
 * Commissioner-safe explanation for a verified-live-handoff autopilot publish.
 * Intentionally plain-language: no VOD/candidate/sync/policy/model terminology.
 */
export const AUTOPILOT_PUBLISHED_COPY =
  'LSC automatically archived this game because the live stream, matchup, and VOD all matched with strong confidence.';

const VERIFIED_LIVE_HANDOFF_AUTOPILOT = 'verified_live_handoff_autopilot';

export function isAutopilotPublished(
  archive?: Pick<LscArchiveItem, 'autopilot_published' | 'publish_source'> | null
): boolean {
  if (!archive) return false;
  if (archive.autopilot_published) return true;
  return archive.publish_source === VERIFIED_LIVE_HANDOFF_AUTOPILOT;
}

type AutopilotPublishedBadgeProps = {
  className?: string;
};

const AutopilotPublishedBadge: React.FC<AutopilotPublishedBadgeProps> = ({ className }) => (
  <span
    className={`inline-flex items-center gap-1 rounded-full border border-emerald-700/60 bg-emerald-900/30 px-2.5 py-0.5 text-xs font-semibold text-emerald-200 ${
      className ?? ''
    }`}
    data-testid="autopilot-published-badge"
    title={AUTOPILOT_PUBLISHED_COPY}
  >
    Autopilot published
  </span>
);

export default AutopilotPublishedBadge;
